import { useEffect } from "react";

interface JsonLdProps {
  id: string;
  data: string;
}

export default function JsonLd({ id, data }: JsonLdProps) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.textContent = data;
    document.head.appendChild(script);
  }, [id, data]);

  return null;
}